<template>
    <div id="app">
        <!-- <router-view /> -->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>

export default {
    created() {
      
        SmartCity.hideTopView({
            isShow: 0,
        });
    },
}
</script>
<style lang="less" scoped>
#app {
  color: #333;
  font-size: 14px;
  height: 100vh;
}

#app::-webkit-scrollbar {
  display: none;
}
</style>
